import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { realtimeClient } from '#pplx_generated/typespec/rest/realtime/client.js';
export async function getSonioxTranscriptionSession({ body, reason, }) {
    try {
        const { data, error, response } = await realtimeClient.POST('/rest/realtime/v1/transcription/soniox-api-key', reason, {
            timeoutMs: getQueryTimeoutMs({ productionMs: 5000 }),
            numRetries: 1,
            body,
            headers: {
                'content-type': 'application/json',
            },
        });
        if (error || !data) {
            return {
                data: null,
                status: response.status,
                error: `Failed to get Soniox transcription session: ${response.statusText}`,
            };
        }
        return {
            data,
            status: response.status,
            error: null,
        };
    }
    catch (err) {
        logger.error('Failed to get Soniox transcription session', err);
        return {
            data: null,
            status: 500,
            error: `Failed to get Soniox transcription session: ${err}`,
        };
    }
}
//# sourceMappingURL=api.js.map